import type { RouteRecordRaw } from "vue-router";
import { ONBOARDING_GUIDE_ROUTE_NAME } from "@/views/onboarding-guide/constants";

const onboardingGuideRoutes: RouteRecordRaw[] = [
  {
    path: "/onboarding-guide",
    name: ONBOARDING_GUIDE_ROUTE_NAME,
    meta: {
      label: "新手引导演示",
      auth: true,
      layout: "blank",
      useTopbar: false,
      layoutHidden: true
    },
    component: () => import("@/views/onboarding-guide/index.vue")
  }
];

export default onboardingGuideRoutes;
